module.exports = __webpack_public_path__ + "static/media/2.38becf65.jpg";